import {
  SEO_AIRPORT_TEMPLATE,
  SEO_A2C_ROUTE_TEMPLATE,
  SEO_AIRPORT_HOME_PAGE,
  SEO_CITY_HR_TEMPLATE,
  SEO_RENTAL_HOME_PAGE,
  SEO_C2A_ROUTE_TEMPLATE
} from '../constants/templateConstants';
import {
  CAB_FROM_AIRPORT,
  RENTALS,
  OUTSTATION_ONE_WAY,
  isOutstationCheck,
  CAB_TO_AIRPORT
} from '../constants/tripTypes';

export const isWebView = () => {
  return (
    window &&
    window['mmt_android_bridge'] &&
    window['mmt_android_bridge']['openDeeplink']
  );
};

export const isSSR = () => typeof window === 'undefined';

export const getCmpFromUrl = () => {
  const url = window.location.href;
  const cmp = url.split('cmp=')[1];
  if (cmp) {
    return cmp;
  }
  return null;
};

export const isMobile = () =>
  !isSSR() && window.matchMedia('(max-width: 768px)').matches;

export const isDesktop = () =>
  !isSSR() && window.matchMedia('(min-width: 769px)').matches;

export const andOfElements = arr => {
  for (const elem of arr) {
    if (elem === false) return false;
  }
  return true;
};

export const orOfElements = arr => {
  for (const elem of arr) {
    if (elem === true) return true;
  }
  return false;
};

export const detectUserActivity = () => {
  localStorage.removeItem('userActionDone');
  ['click'].forEach(evt =>
    document.body.addEventListener(evt, () => {
      if (window?.localStorage) {
        localStorage.setItem('userActionDone', 'true');
      }
    })
  );
};

export const detectUserScroll = () => {
  localStorage.removeItem('userScrolled'); // Clear any existing flag
  const handleScroll = () => {
    if (window?.localStorage) {
      localStorage.setItem('userScrolled', 'true'); // Set the flag when the user scrolls
      window.removeEventListener('scroll', handleScroll); // Remove the listener after detecting scroll
    }
  };

  window.addEventListener('scroll', handleScroll); // Attach the scroll event listener
};

export const pageLoadedInBrowser = () => {
  return typeof window != 'undefined';
};

export const useSearchWidgetHooks = template => {
  const travelFor = (() => {
    if (
      SEO_AIRPORT_TEMPLATE === template ||
      SEO_A2C_ROUTE_TEMPLATE === template ||
      SEO_AIRPORT_HOME_PAGE === template
    ) {
      return CAB_FROM_AIRPORT;
    } else if (SEO_C2A_ROUTE_TEMPLATE === template) {
      return CAB_TO_AIRPORT;
    } else if (
      SEO_CITY_HR_TEMPLATE === template ||
      SEO_RENTAL_HOME_PAGE === template
    )
      return RENTALS;
    return OUTSTATION_ONE_WAY;
  })();

  const pickUpTime = isOutstationCheck(travelFor) ? '10:00 AM' : '3:00 PM';
  const dropTime = isOutstationCheck(travelFor) ? '12:00 PM' : '5:00 PM';
  return {
    travelFor,
    pickUpTime,
    dropTime
  };
};
export const generateRequestId = () => {
  const characters = 'ABCDEFGHIJKLMNPQRTUVWXYZ0123456789';
  const requestIdLength = 6;
  let requestId = 'S';
  for (let i = 1; i < requestIdLength; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    requestId += characters[randomIndex];
  }
  return requestId;
};

export const getServiceDeskRequestBody = (reqId, pageName) => {
  const req = {
    source: 'seo_whatsapp_icon',
    funnel_page_name: pageName,
    request_id: reqId,
    type: 'SeoMyDeskRequestCreateRequest'
  };
  return req;
};

export const isInternationalPage = () => {
  // @ts-ignore
  return (
    typeof window !== 'undefined' &&
    window.__INITIAL_STATE__ &&
    window.__INITIAL_STATE__.isInternational
  );
};

export const isSEM = () => {
  if (!isSSR() && window?.location?.href != null) {
    const url = new URL(window.location.href);
    if (url.searchParams.get('source')) {
      return url.searchParams.get('source')?.toUpperCase() === 'SEM';
    }
  }
};

export const isCrawler = () => {
  if (isSSR()) {
    return false;
  }
  return /bot|googlebot|crawler|spider|robot|crawling|curl|wget|postman/i.test(
    navigator.userAgent
  );
};

/**
 * Fetch and log XDM event for page load
 * Uses require() to avoid circular dependency issues
 * @param url - The URL to track (from window.location.href or data.url)
 */
export const fetchAndLogXdmEvent = async (url: string) => {
  try {
    // Lazy load to avoid circular dependencies
    const { getXdmEventData } = require('../cabsAPIs');
    const {
      logEventToXDM,
      analyticsSDK
    } = require('../xdmLogging/fireEventHelper');

    const request = { url };
    const xdmEventData = await getXdmEventData(request);

    if (xdmEventData) {
      const sessionId = await analyticsSDK.getSessionId();
      xdmEventData.event_tracking_context.session_id = sessionId;
      logEventToXDM(xdmEventData);
    }
  } catch (error) {
    console.error('Error logging XDM event:', error);
  }
};
